export const normalize = (x, a, b) => (b !== a ? (x - a) / (b - a) : 0);

export const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);

export const fitClamped = (x, a, b, c, d) =>
  c + (d - c) * clamp01(normalize(x, a, b));
